import {
  Font,
   StyleSheet,
} from "@react-pdf/renderer";
import React from "react";

Font.register({ family: "ming", src: "./fonts/wt002.ttf" });
Font.register({ family: "oswald regular", src: "./fonts/Oswald-Regular.ttf" });
Font.register({ family: "oswald medium", src: "./fonts/Oswald-Medium.ttf" });
Font.register({ family: "oswald bold", src: "./fonts/Oswald-Bold.ttf" });


export const details_styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 15,
    marginBottom: 35,
    paddingBottom: 35
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  heading: {
    fontFamily: "oswald bold",
    textAlign: "center",
    fontSize: 18,
    paddingTop: 5

  },
  title: {
    fontFamily: "oswald medium",
    textAlign: "center",
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },
  subTitle: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    paddingBottom: 5,
  },
  subTitleChn: {
    fontFamily: "ming",
    textAlign: "center",
    fontSize: 10,
    paddingBottom: 5,
  },
  content: {
    fontFamily: "ming",
    margin: "10px",
    fontSize: 12,
    borderTop: 1
  },
  address: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    borderBottom: 1,
    paddingBottom: 5
  },
  footer: {
    fontFamily: "oswald regular",
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    left: 35,
    right: 25,
    textAlign: 'right',
  },
  detailContainer: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline'
  },
  tableHead: {
    fontFamily: "oswald bold",
    fontSize: 10,
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    paddingTop: 5,
    borderTop: 1,
    alignItems: 'baseline'
  },
  tableHeadLabel: {

  },
  totalContainer: {
    fontFamily: "oswald bold",
    fontSize: 10,
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline'
  },
  detailContainerGray: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline',
    backgroundColor: '#F0F0F0',
  },
  chnDetails: {
    fontFamily: "ming",
    fontSize: 10,
    paddingLeft: 5,

  },
  engDetails: {
    fontFamily: "oswald regular",
    fontSize: 10,
  },
  amount: {
    fontFamily: "oswald regular",
    fontSize: 10,
    textAlign: 'right',
    marginLeft: 5
  },
});


export const summary_styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 15,
    marginBottom: 35
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  heading: {
    fontFamily: "oswald bold",
    textAlign: "center",
    fontSize: 18,
    paddingTop: 5

  },
  title: {
    fontFamily: "oswald medium",
    textAlign: "center",
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },
  subTitle: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    paddingBottom: 5,
  },
  content: {
    fontFamily: "ming",
    margin: "10px",
    fontSize: 12,
    borderTop: 1
  },
  address: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    borderBottom: 1,
    paddingBottom: 5
  },
  footer: {
    fontFamily: "oswald regular",
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    left: 35,
    right: 25,
    textAlign: 'right',
  },
  detailContainer: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline'
  },
  totalContainer: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    borderTop: 1,
    alignItems: 'baseline'
  },
  detailContainerGray: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline',
    backgroundColor: '#F0F0F0',
  },
  chnDetails: {
    fontFamily: "ming",
    fontSize: 10,
    paddingLeft: 5,

  },
  engDetails: {
    fontFamily: "oswald regular",
    fontSize: 10,
    width: '300px',
    paddingLeft: 5
  },
  total: {
    fontFamily: "oswald regular",
    fontSize: 10,
    textAlign: 'right',
    width: '200px',
    paddingLeft: 5
  },


});

export const memberlist_styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 15,
    marginBottom: 35
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  heading: {
    fontFamily: "oswald bold",
    textAlign: "center",
    fontSize: 18,
    paddingTop: 5

  },
  address: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    borderBottom: 1,
    paddingBottom: 5
  },
  title: {
    fontFamily: "oswald medium",
    textAlign: "center",
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },

  content: {
    fontFamily: "ming",
    margin: "10px",
    fontSize: 12,
    borderTop: 1
  },
  footer: {
    fontFamily: "oswald regular",
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    left: 35,
    right: 25,
    textAlign: 'right',
  },
  detailContainer: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline'
  },
  detailContainerGray: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    alignItems: 'baseline',
    backgroundColor: '#F0F0F0',
  },
  label: {
    fontFamily: "oswald bold",
    fontSize: 12,
    //flexGrow:1
  },
  chnDetails: {
    fontFamily: "ming",
    fontSize: 10,
    paddingLeft: 5,
    fontWeight: 'bold'
    //flexGrow:9
  },
  engDetails: {
    fontFamily: "oswald regular",
    fontSize: 10,
    paddingLeft: 5
    //flexGrow:9
  },

});

export const receipts_styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 12
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  heading: {
    fontFamily: "oswald bold",
    textAlign: "center",
    fontSize: 18,
    paddingTop: 5

  },
  address: {
    fontFamily: "oswald regular",
    textAlign: "center",
    fontSize: 10,
    borderBottom: 1,
    paddingBottom: 5
  },
  title: {
    fontFamily: "oswald medium",
    textAlign: "center",
    fontSize: 16,
    paddingTop: 5,
    paddingBottom: 5,
  },

  content: {
    height: "182px",
    fontFamily: "ming",
    margin: "10px",
    fontSize: 12,
    borderTop: 1
  },
  footer: {
    height: "20px"
  },
  detailContainer: {
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    alignItems: 'baseline'
  },
  label: {
    fontFamily: "oswald bold",
    fontSize: 12,
    //flexGrow:1
  },
  chnDetails: {
    fontFamily: "ming",
    fontSize: 10,
    paddingLeft: 5,
    fontWeight: 'bold'
    //flexGrow:9
  },
  engDetails: {
    fontFamily: "oswald regular",
    fontSize: 10,
    paddingLeft: 5
    //flexGrow:9
  },

  signLabel: {
    fontFamily: "oswald medium",
    fontSize: 12,
    flexGrow: 2
  },

  sign: {
    fontFamily: "oswald medium",
    fontSize: 12,
    flexGrow: 1
  },
});


const PDFSaved = props => {
  // function that call the parent's function reset the ready flag
  props.doFinish();
  return <div />;
};


export { PDFSaved }